import React, { useContext } from 'react';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListSubheader from '@mui/material/ListSubheader';
import DescriptionIcon from '@mui/icons-material/Description';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PublicIcon from '@mui/icons-material/Public';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import EmailIcon from '@mui/icons-material/Email';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PeopleIcon from '@mui/icons-material/People';
import FolderIcon from '@mui/icons-material/Folder';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LabelIcon from '@mui/icons-material/Label';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BusinessIcon from '@mui/icons-material/Business';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import QuizIcon from '@mui/icons-material/Quiz';
import useRouter from '../../components/_hook/useRouter';
import useRoutes from '../../components/_hook/useRoutes';
import DrawerListItem from '../../components/_header/DrawerListItem';
import Context from '../../context';

export default function BusinessDrawer() {
  const { path } = useRoutes();
  const { params } = useRouter();
  const { company } = useContext(Context);
  const { t } = useTranslation();

  return (
    <>
      <List dense>
        <DrawerListItem
          path={path('business.dashboard', {
            companyID: company._id,
          })}
          primaryText={t('dashboard')}
          icon={<DashboardIcon />}
        />
        <ListSubheader>{t('detail', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.profile', {
            companyID: company._id,
          })}
          primaryText={t('profile')}
          icon={<DescriptionIcon />}
          className="business-drawer-profile-list-item-joyride"
        />
        <DrawerListItem
          path={path('business.commercial_practice', {
            companyID: company._id,
          })}
          primaryText={t('commercial_practice')}
          icon={<AttachMoneyIcon />}
        />
        <DrawerListItem
          path={path('business.market_coverage', {
            companyID: company._id,
          })}
          primaryText={t('market_coverage')}
          icon={<PublicIcon />}
        />
        <DrawerListItem
          path={path('business.shipping_method.list', {
            companyID: company._id,
          })}
          primaryText={t('shipping_method', { count: 2 })}
          icon={<LocalShippingIcon />}
        />
        <DrawerListItem
          path={path('business.payment_method.list', {
            companyID: company._id,
          })}
          primaryText={t('payment_method', { count: 2 })}
          icon={<LocalAtmIcon />}
        />
        <ListSubheader>{t('contact', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.branch', {
            companyID: company._id,
          })}
          primaryText={t('branch_and_contact', { count: 2 })}
          icon={<RecentActorsIcon />}
          className="business-drawer-branch-list-item-joyride"
        />
        <DrawerListItem
          path={path('business.contacts', {
            companyID: company._id,
          })}
          primaryText={t('email_and_link', { count: 2 })}
          icon={<EmailIcon />}
          className="business-drawer-contact-list-item-joyride"
        />
        <ListSubheader>
          {t('department_and_employee', { count: 2 })}
        </ListSubheader>
        <DrawerListItem
          path={path('business.departments', {
            companyID: company._id,
          })}
          primaryText={t('department', { count: 2 })}
          icon={<AccountTreeIcon />}
        />
        <DrawerListItem
          path={path('business.employees', {
            companyID: company._id,
          })}
          primaryText={t('employee', { count: 2 })}
          icon={<PeopleIcon />}
        />
        <ListSubheader>{t('keyword', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.keyword.classifications', {
            companyID: company._id,
          })}
          primaryText={t('keyword', { count: 2 })}
          icon={<FolderIcon />}
        />
        <DrawerListItem
          path={path('business.keyword.brands', {
            companyID: company._id,
          })}
          primaryText={t('brand', { count: 2 })}
          icon={<LabelIcon />}
        />
        <DrawerListItem
          path={path('business.keyword.tags', {
            companyID: company._id,
          })}
          primaryText={t('tag', { count: 2 })}
          icon={<LocalOfferIcon />}
        />
        <ListSubheader>
          {t('follow')}&nbsp;<span style={{ color: 'red' }}>({t('new')})</span>
        </ListSubheader>
        <DrawerListItem
          path={path('business.follow.explore', {
            companyID: company._id,
          })}
          primaryText={t('explore')}
          icon={<TravelExploreIcon />}
        />
        <DrawerListItem
          path={path('business.follow.following', {
            companyID: company._id,
          })}
          primaryText={t('following', { count: 2 })}
          icon={<BusinessIcon />}
        />
        <DrawerListItem
          path={path('business.follow.followers', {
            companyID: company._id,
          })}
          primaryText={t('follower', { count: 2 })}
          icon={<SupervisorAccountIcon />}
        />
        <ListSubheader>{t('subdirectory')}</ListSubheader>
        <DrawerListItem
          path={path('business.subdirectory.tags', {
            companyID: company._id,
          })}
          primaryText={`${t('subdirectory')} ${t('tag', { count: 2 })}`}
          icon={<LocalOfferIcon />}
        />
        <ListSubheader>{t('media', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.logo', {
            companyID: company._id,
          })}
          primaryText={t('business_logo')}
          icon={<ImageIcon />}
          className="business-drawer-logo-list-item-joyride"
        />
        <DrawerListItem
          path={path('business.banner', {
            companyID: company._id,
          })}
          primaryText={t('banner', { count: 2 })}
          icon={<ImageIcon />}
          className="business-drawer-banner-list-item-joyride"
        />
        {/* <DrawerListItem */}
        {/*  path={path('business.advertisement', { */}
        {/*    companyID: company._id, */}
        {/*  })} */}
        {/*  primaryText={t('advertisement', { count: 2 })} */}
        {/*  icon={<ImageIcon />} */}
        {/* /> */}
        <DrawerListItem
          path={path('business.catalogue', {
            companyID: company._id,
          })}
          primaryText={t('catalogue', { count: 2 })}
          icon={<InsertDriveFileIcon />}
        />
        <ListSubheader>{t('page', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.page.main_page', {
            companyID: company._id,
          })}
          primaryText={t('main_page', { count: 2 })}
          icon={<FileCopyIcon />}
        />
        <DrawerListItem
          path={path('business.page.faq', {
            companyID: company._id,
          })}
          primaryText={t('faq_page', { count: 2 })}
          icon={<QuizIcon />}
        />
        <ListSubheader>{t('setting', { count: 2 })}</ListSubheader>
        <DrawerListItem
          path={path('business.setting', {
            companyID: company._id,
          })}
          primaryText={t('configuration', { count: 2 })}
          icon={<SettingsIcon />}
        />
      </List>
    </>
  );
}
